import { SelectItem } from 'primeng/api/selectitem';
import { ConfirmDialogData } from './common';
import { ApiResult } from './PromiseResult';
import { Form_Data, OtpData, PasswordInput, RecaptchaData, TabView_Data } from './util.models';

export class Privileges {
    si_no: string;
    name: string;
}
export class MedicalSchool extends Privileges {
    year: string;
}

export class Fellowship extends MedicalSchool { }

export class StatesToPractice {
    si_no: string;
    state_name: string;
    state_id: number;
    license_no: string;
    state_data: string;
}

export class Honours extends Privileges { }

export class Residency extends MedicalSchool { }

export class Board extends Privileges { }

export class Publication extends Privileges { }

export class LanguageSpoken {
    english_name: string;
    id: number;
    language_name: string;
    label: string;
}

export class Role {
    role_id: any;
    name: string;
}

export class CountrySelectedValue {
    id: number = 0;
    is_national_license: boolean = null;
    phone_code: string = "";
    country_name?: string = "";
    acronym?: string = "";
}

export class StateSelectedValue {
    id: number;
    state_name: string;
}

export class doctor_register_api_data {
    recaptcha: string;
    salutation: string;
    d_email: string;
    d_password: string;
    confirm_d_password: string;
    first_name: string;
    middle_name: string;
    last_name: string;
    gender: string;
    date_of_birth: string;
    date_of_birth_date: Date;
    country_id: number;
    state_name: string;
    city: string;
    address_line_1: string;
    address_line_2: string;
    zip_code: string;
    role_id: number;
    primary_speciality_id: number;
    secondary_speciality: string[];
    featured_doctor_id: boolean;
    years_experience: number;
    license_number: string;
    degree: string;
    is_doctor: boolean;
    education: {
        medical_school: MedicalSchool[];
        residency: Residency[];
        fellowship: Fellowship[];
    };
    timezone: number;
    npi_number: string;
    revalidation_cme: number;
    states_to_practice: StatesToPractice[];
    board_certification: string[];
    honors_awards_recognition: string[];
    publications: string[];
    hospital_privileges: string[];
    description: string;
    primary_contact_number: string;
    secondary_contact_number: string;
    pin: string;
    language_id: string[];
    avatar: File;
    resume: File;
    user_source_id: number;
    other_user_source: string;
    gmc_reg_no: string;
    passing_year: string;
    certificates: File;
    certificates_data: string[];
}

export class dregistration {
    api_data: doctor_register_api_data;
    form_data: Form_Data = new Form_Data();
    others: {
        selected_country: string;
        selected_country_data: CountrySelectedValue;
        selected_state: string;
        selected_state_data: StateSelectedValue;
        primary_number: string;
        phone_code: string;
        is_national_license: boolean;
        secondary_number: string;
        // password_masking: boolean;
        // pin_masking: boolean;
        // password_tips: boolean;
        passwordData: PasswordInput;
        pinData: PasswordInput;
        recaptchaData: RecaptchaData;
        // confirm_password: string;
        national_license_number: string;
        MedicalSchool: MedicalSchool[];
        Fellowship: Fellowship[];
        StatesToPractice: StatesToPractice[];
        Honours: Honours[];
        Privileges: Privileges[];
        Residency: Residency[];
        Board: Board[];
        Publication: Publication[];
        agree: boolean;
        // resume: File;
        // profilePhoto: File;
        signatureOptionSelected: string;
        signatureFile: File;
        is_super_admin: boolean;
        fetchDataDialog: ConfirmDialogData;
        successDialog: ConfirmDialogData;
        show_form: boolean;
        formData_apiResult: ApiResult;
        form_error_message_result: ApiResult;
        // formData_response: PromiseResult;
        // profilePhoto_response: PromiseResult;
        // resume_response: PromiseResult;
        tabViewData: TabView_Data;
        otp_data: OtpData;
        email: string;
        user_source: SelectItem[];
    };
    others_data: {
        countries: SelectItem[];
        states: SelectItem[];
        languages: SelectItem[];
        salutations: SelectItem[];
        primary_specialties: SelectItem[];
        secondary_specialties: SelectItem[];
        years: SelectItem[];
        year: number;
        form_data: Form_Data;
    };
    // temp: DoctorRegTemp;
    // temp_id: DoctorRegTemp_id;
    // current_temp: DoctorRegTemp;
    table_data: DoctorRegTable;
}

export class DoctorRegTemp {
    MedicalSchool: MedicalSchool;
    Fellowship: Fellowship;
    StatesToPractice: StatesToPractice;
    Honours: Honours;
    Privileges: Privileges;
    Residency: Residency;
    Board: Board;
    Publication: Publication;
}

export class DoctorRegTemp_id {
    MedicalSchool: number;
    Fellowship: number;
    StatesToPractice: number;
    Honours: number;
    Privileges: number;
    Residency: number;
    Board: number;
    Publication: number;
}

export class DoctorSaveData {
    local_storage_object_name: string;
    masterChecker: boolean;
}

export class DoctorRegTable {
    MedicalSchool: TableData;
    Fellowship: TableData;
    StatesToPractice: TableData;
    Honours: TableData;
    Privileges: TableData;
    Residency: TableData;
    Board: TableData;
    Publication: TableData;
}

export class Column {
    field: string;
    header: string;
    is_edit: boolean;
    is_key: boolean;
    is_display: boolean;
    input_type: string;
    data_type: string;
    data: SelectItem[];
    th_class_name: string;
    tr_class_name: string;
    input_class_name: string;
    is_data_field: boolean;
}

export class TableData {
    columns: Column[];
    refresh: boolean;
}

export class saveProfileData {
    user_guid: string;
    d_email: string;
    egd_email: string;
    first_name: string;
    middle_name: string;
    last_name: string;
    date_of_birth: string;
    gender: string;
    country_id: number;
    state_name: string;
    address_line_1: string;
    address_line_2: string;
    city: string;
    zip_code: string;
    avatar_url: string;
    doctor_profile: {
        user_guid: string;
        degree: string;
        primary_speciality_id: number;
        secondary_speciality: string[];
        salutation: string;
        language_id: string[];
        years_experience: number;
        education: {
            medical_school: MedicalSchool[];
            residency: Residency[];
            fellowship: Fellowship[];
        };
        timezone: number;
        license_number: string;
        npi_number: string;
        revalidation_cme: string;
        states_to_practice: StatesToPractice[];
        board_certification: string[];
        honors_awards_recognition: string[];
        publications: string[];
        description: string;
        hospital_privileges: string[];
        primary_contact_number: string;
        secondary_contact_number: string;
        pin: string;
        resume_url: string;
        resume_key: string;
    };
}

export class boolean_dregistration {
    first_name: boolean;
    // middle_name: boolean; //nr
    last_name: boolean;
    gender: boolean;
    d_email: boolean;
    date_of_birth: boolean;
    d_password: boolean;
    confirm_d_password: boolean;
    d_password_equal: boolean;
    // date_of_birth_date: boolean;//nr
    language_id: boolean;
    role_id: boolean; //nr-c //*
    featured_doctor_id: boolean; //nr-c //*
    country_id: boolean;
    city: boolean;
    address_line_1: boolean;
    primary_contact_number: boolean;
    state_name: boolean;
    zip_code: boolean;
    // address_line_2: boolean; //nr
    // secondary_contact_number: boolean; //nr
    primary_speciality_id: boolean;
    // secondary_speciality: boolean; //nr
    salutation: boolean;
    years_experience: boolean;
    npi_number: boolean;
    degree: boolean;
    // revalidation_cme: boolean; //nr
    // license_number: boolean; //nr
    states_to_practice: boolean;
    // education: {
    medical_school: boolean; //*
    // residency: boolean; //*
    // fellowship: boolean; //nr
    // };
    // board_certification: boolean;
    // publications: boolean; //nr
    // honors_awards_recognition: boolean; //nr
    // hospital_privileges: boolean; //nr
    profile_photo: boolean; //*
    // resume_cv:boolean; //nr
    pin: boolean;
    signature: boolean; //*
    description: boolean;
    recaptcha: boolean; //*
    agree: boolean; //*
    pin_number_string: boolean;
    primary_contact_number_number_string: boolean;
    user_source_id: boolean;
    other_source?: boolean;

    // timezone: boolean; //nr

    // has_saved: boolean;  //nr
    // current_guid: boolean;  //nr
    // referral_doctor_guid: boolean;  //nr
    // token:boolean;  //nr
    // is_doctor:boolean;  //nr
}

export class labels_doctorreg {
    first_name: string;
    last_name: string;
    gender: string;
    d_email: string;
    date_of_birth: string;
    language_id: string;
    role_id: string;
    featured_doctor_id: string;
    d_password: string;
    confirm_d_password: string;
    country_id: string;
    city: string;
    address_line_1: string;
    primary_contact_number: string;
    state_name: string;
    zip_code: string;
    primary_speciality_id: string;
    primary_occupation: string;
    salutation: string;
    license_number: string;
    years_experience: string;
    years_of_experience: string;
    npi_number: string;
    degree: string;
    states_to_practice: string;
    school: string;
    medical_school: string;
    residency: string;
    board_certification: string;
    profile_photo: string;
    resume_cv: string;
    pin: string;
    signature: string;
    description: string;
    recaptcha: string;
    agree: string;
    pin_number_string: string;
    primary_contact_number_number_string: string;
    user_source_id: string;
    other_source: string;
}
